module.exports = __webpack_public_path__ + "static/img/step-introduce-in.ff0520b7.png";